import ChatParticipants from './ChatParticipants';

export default ChatParticipants;
